// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__DK0or","empty":"ModalGraph_empty__1BJ2m"};